module.exports = __webpack_public_path__ + "static/img/service-code.74eb36c6.jpg";